import { SingleCardItem, SubTitle, Title } from "components/views/ui";

const CTF2023 = () => {
  return (
    <SingleCardItem>
      <Title
        title={
          "CTF Victory: Ministry of Internal Affairs and Communications West Japan Cross-Regional Cybersecurity Grand Prix @Tokushima Venue"
        }
        hyperLink="https://www.soumu.go.jp/soutsu/kinki/topics/01sotsu07_01002069.html"
      />
      <SubTitle title={"06/2023"} />
    </SingleCardItem>
  );
};

export default CTF2023;
